import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    Renderer2
} from '@angular/core';
import { EXERCISE_CALCULATION, EXERCISE_SEQUENCE } from '@app/app.constants';

import { crossIcon } from '@app/app.constants';
import { Answer } from '@app/definitions/interfaces';
import { IExercise } from '@df/interfaces/exercise';
import { KATEX_FORMAT } from '@app/app.constants';
import { PupilService } from '@app/student/services/pupil.service';

@Component({
    selector: 'app-pupil-exercise',
    templateUrl: './pupil-exercise.component.html',
    styleUrls: ['../../../_pipes/exercise-format.pipe.scss', './pupil-exercise.component.scss']
})
export class PupilExerciseComponent implements AfterViewInit, OnChanges, OnInit {
    @Input() exercise: any;
    @Input() selectedExerciseIndex: number;
    @Input() studentId: number;
    @Input() cardId: number;
    @Input() sequenceInstruction: string;
    @Input() answerString = '';
    @Input() isFinishCard: boolean = false;

    @Output() answered = new EventEmitter();
    @Output() exerciseCompleted = new EventEmitter();
    @Output() exerciseCorrect = new EventEmitter();

    errorMessage: string = null;
    buttons: any[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '+', '-', '*', '/'];
    taskAnswersString: string[] = [];
    answeredQuestionCount: number = 0;
    correctQuestionCount: number = 0;
    sequence: string = EXERCISE_SEQUENCE;
    calculation: string = EXERCISE_CALCULATION;

    crossIcon = crossIcon;

    private viewInit = false;
    private minimumTextSize = 10;

    constructor(private elRef: ElementRef, private renderer: Renderer2, private pupilService: PupilService) {}

    ngOnInit() {
        // console.log(this.exercise);
        if (this.exercise.answers.length > 0) {
            const answer = this.exercise.answers[0].shortAnswer;
            const signs = ['>', '<', '='];
            for (const sign of signs) {
                if (answer.includes(sign) && !this.buttons.includes(sign)) {
                    this.buttons = this.buttons.concat(signs);
                    break;
                }
            }
        }
    }

    ngAfterViewInit() {
        if (!this.viewInit) {
            this.renderer.setStyle(this.questionDiv, 'fontSize', `${this.minimumTextSize}px`);
            this.calculateSize();
        }

        this.viewInit = true;
    }

    ngOnChanges(): void {
        if (this.viewInit) {
            this.calculateSize();
        }
    }

    calculateSize() {
        const questionSpan = this.elRef.nativeElement.querySelector('.question_text');

        let questionDivWidthNum = this.getWidth(this.questionDiv);
        let questionSpanWidthNum = this.getWidth(questionSpan);
        let tries = 0;
        while (Math.abs(questionSpanWidthNum - questionDivWidthNum) > 10 && tries < 50) {
            let fontSizeNum = Number(window.getComputedStyle(this.questionDiv).fontSize.replace('px', ''));
            if (questionSpanWidthNum >= questionDivWidthNum) {
                fontSizeNum--;
            } else {
                fontSizeNum++;
            }
            tries++;
            this.renderer.setStyle(this.questionDiv, 'fontSize', `${fontSizeNum}px`);
            questionDivWidthNum = this.getWidth(this.questionDiv);
            questionSpanWidthNum = this.getWidth(questionSpan);
        }
    }

    private get questionDiv(): any {
        return this.elRef.nativeElement.querySelector('#question');
    }

    private getWidth(el: Element): number {
        return el.getBoundingClientRect().width;
    }

    keyboardClicked(button: number | string) {
        this.answerString += button.toString();

        // Calculate answer input style
        const questionInput = this.elRef.nativeElement.querySelector('.answer_input');
        const bufferDiv = this.elRef.nativeElement.querySelector('.buffer');

        if (this.answerString.length === 0) {
            this.renderer.setStyle(questionInput, 'fontSize', '70px');
        }
        const computedStyle = window.getComputedStyle(questionInput);
        const fontSize = computedStyle.fontSize;
        let fontSizeNum = Number(fontSize.replace('px', ''));

        this.renderer.setStyle(bufferDiv, 'fontSize', fontSize);
        this.renderer.setProperty(bufferDiv, 'innerHTML', this.answerString);

        const bufferDivWidth = window.getComputedStyle(bufferDiv).width;
        let bufferDivWidthNum = Number(bufferDivWidth.replace('px', ''));
        const questionInputWidth = window.getComputedStyle(questionInput).width;
        const questionInputWidthNum = Number(questionInputWidth.replace('px', ''));

        // decrease font
        const symbolsInInput: number = 6;
        if (this.answerString.length > symbolsInInput && fontSizeNum > 18) {
            while (bufferDivWidthNum + fontSizeNum > questionInputWidthNum) {
                fontSizeNum -= 4;
                this.renderer.setStyle(questionInput, 'fontSize', `${fontSizeNum}px`);
                this.renderer.setStyle(bufferDiv, 'fontSize', `${fontSizeNum}px`);
                bufferDivWidthNum = Number(window.getComputedStyle(bufferDiv).width.replace('px', ''));
            }
        }
    }

    clearAnswer() {
        this.answerString = '';
    }

    removeUnnecessaryInput(answer) {
        const reUnnecessary = /\(.*?\)/g;
        return answer.replace(reUnnecessary, '').trim();
    }

    checkAnswer() {
        let isCorrect: boolean = false;

        if (this.answerString) {
            for (const answ of this.exercise.answers) {
                let shortAnswer = this.removeUnnecessaryInput(answ.shortAnswer);
                shortAnswer = this.pupilService.replaceFrac(shortAnswer);
                if (this.answerString === shortAnswer || this.answerString === answ.fullAnswer) {
                    isCorrect = true;
                    break;
                }
            }
        }

        const exerciseAnswer: Answer = {
            student: this.studentId,
            card: this.cardId,
            shortAnswer: this.answerString,
            exercise: this.exercise.id,
            correct: isCorrect
        };

        this.clearAnswer();

        this.answered.emit(exerciseAnswer);
        // send if exercise is correct
        if (isCorrect) {
            this.exerciseCorrect.emit(true);
        } else {
            this.exerciseCorrect.emit(false);
        }
        this.exerciseCompleted.emit(true);
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }

    checkAnswersPerString() {
        return this.pupilService.checkAnswersPerString(this.exercise);
    }

    updateAnswer(event) {
        this.answerString += event.target.value;
    }
}
